<div
	[formGroup]="formParams"
	class="zk-flex zk-flex-wrap zk-mb-4 zk-gap-4 billing-data"
	*ngIf="formParams"
>
	<section
		class="
			zk-flex zk-w-full
			lg:zk-flex-row
			xl:zk-flex-row
			md:zk-flex-col
			sm:zk-flex-col
		"
		*ngIf="formParams.get('businessFiscalId')"
	>
		<!-- CPF INPUT -->
		<div class="zk-w-full lg:zk-w-12/12 xl:zk-w-12/12 ficalIdContainer">
			<zk-input
				class="lg:zk-mt-3 xl:zk-mt-3 sm:zk-mt-1"
				(change)="changeInputIdwall($event)"
				[zkStatus]="isFieldInvalid('fiscalId') ? 'error' : 'default'"
			>
				<input
					id="billing-fiscal-id"
					zkInputRef
					required
					[mask]="'000.000.000-00'"
					formControlName="fiscalId"
					[disabled]="validationRequired"
					placeholder="{{
						'MY_ACCOUNT.FINANCIAL.BILLING_DATA.FISCAL_ID' | translate
					}}"
				/>

				<span zkInputLabel
					>{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.FISCAL_ID' | translate }}
				</span>
				<span
					zkInputMessage
					class="fiscalIdMgError"
					[class.zk-hidden]="!isFieldInvalid('fiscalId')"
				>
					<ng-container *ngIf="!formParams.get('fiscalId').value">
						{{
							'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.FISCAL_ID' | translate
						}}
					</ng-container>
					<ng-container *ngIf="formParams.get('fiscalId').value">
						{{
							'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.FISCAL_ID_INVALID'
								| translate
						}}
					</ng-container>
				</span>
			</zk-input>
		</div>

		<!-- CNPJ INPUT -->
		<div
			class="
				zk-flex
				lg:zk-flex-row
				xl:zk-flex-row
				sm:zk-flex-col
				zk-w-full
				lg:zk-pl-2
				xl:zk-pl-2
				sm:zk-pl-0
			"
		>
			<div class="lg:zk-w-8/12 xl:zk-w-8/12">
				<zk-input
					class="lg:zk-mt-3 xl:zk-mt-3 sm:zk-mt-4"
					[zkStatus]="isFieldInvalid('businessFiscalId') ? 'error' : 'default'"
					(change)="changeInputIdwall($event)"
				>
					<input
						[class.cnpj-input--valid]="validationLoadingOrSuccess"
						id="billing-business-fiscal-id"
						zkInputRef
						[mask]="'00.000.000/0000-00'"
						formControlName="businessFiscalId"
						[disabled]="validationRequired"
						placeholder="{{
							'MY_ACCOUNT.FINANCIAL.BILLING_DATA.BUSINESS_FISCAL_ID' | translate
						}}"
					/>
					<span zkInputLabel
						>{{
							'MY_ACCOUNT.FINANCIAL.BILLING_DATA.BUSINESS_FISCAL_ID' | translate
						}}
					</span>
					<span
						zkInputMessage
						[class.errorMessage]="!validationLoadingOrSuccess"
						[class.zk-hidden]="validationLoadingOrSuccess"
					>
						<ng-container
							*ngIf="
								isFieldInvalid('businessFiscalId') &&
								!idWallError &&
								formParams.get('businessFiscalId').value
							"
						>
							{{
								'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.BUSINESS_FISCAL_ID_INVALID'
									| translate
							}}
						</ng-container>

						<span *ngIf="idWallError">
							<span class="content-error text-color">
								<div class="error info-icon">
									<span
										class="freud-icon freud-icon-info-circle freud-icon-xs"
									></span>
								</div>
								<div class="error text-label">
									<ng-container *ngIf="idWallError">
										{{ this.idWallError }}
									</ng-container>
								</div>
							</span>
							<div class="cnaeError" *ngIf="isCNAEError">
								<ul>
									<li
										*ngFor="let cnae of CNAEAproved"
										class="subarea-pill selected"
									>
										<span class="text-color" *ngIf="isCNAEError">
											{{ cnae }}
										</span>
									</li>
								</ul>
								<span class="text-color getting-touch">
									{{
										'MY_ACCOUNT.FINANCIAL.BILLING_ADDRESS.ERROR.CNAE_INVALID_RETURN'
											| translate
									}}
								</span>
							</div>
						</span>
					</span>

					<span zkInputMessage *ngIf="onValidationSuccess">
						<img
							[src]="'/assets/images/icons/check_gray.svg'"
							class="cnpj-validation--icon-check"
							alt=""
						/>
						<ng-container>
							<span class="text-color">
								{{
									'MY_ACCOUNT.FINANCIAL.BILLING_DATA.VALIDATION_SUCCESS'
										| translate
								}}
							</span>
						</ng-container>
					</span>

					<span
						zkInputMessage
						class="content-error text-color"
						*ngIf="isValidationTakingWhile"
					>
						<ng-container>
							<div class="error info-icon">
								<span
									class="freud-icon freud-icon-info-circle freud-icon-xs"
								></span>
							</div>
							<span class="error text-label">
								{{
									'MY_ACCOUNT.FINANCIAL.BILLING_DATA.VALIDATION_TOO_LONG'
										| translate
								}}
							</span>
						</ng-container>
					</span>
				</zk-input>
			</div>
			<div
				class="
					lg:zk-w-4/12
					xl:zk-w-4/12
					sm:zk-w-full
					md:zk-w-full
					lg:zk-pt-3
					xl:zk-pt-3
					sm:zk-pt-4
					lg:zk-ml-2
					xl:zk-ml-2
					sm:zk-ml-0
				"
			>
				<freud-button
					[disabled]="!canSendData"
					(click)="onRequestValidation()"
					[loading]="validationRequired"
					size="lg"
				>
					{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.VALIDATE' | translate }}
				</freud-button>
			</div>
		</div>
	</section>
</div>
